import {
  FacebookLoginProvider,
  GoogleLoginProvider,
  GoogleSigninButtonModule,
  SocialAuthService,
} from '@abacritt/angularx-social-login';
import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'offconon-social-login',
  templateUrl: './social-login.component.html',
  styleUrls: ['./social-login.component.scss'],
  imports: [GoogleSigninButtonModule, TranslateModule, ButtonModule, CommonModule],
})
export class SocialLoginComponent implements OnInit {
  private socialAuthService = inject(SocialAuthService);

  @ViewChild('googleSignInButton') googleSignInButton!: ElementRef;
  private router = inject(Router);
  registerPage = false;

  ngOnInit() {
    const currentUrl = this.router.url;
    if (currentUrl.includes('registration')) {
      this.registerPage = true;
    }
  }
  triggerGoogleSignIn(): void {
    // Programmatically trigger the click on the hidden asl-google-signin-button
    const googleButton = this.googleSignInButton.nativeElement.querySelector('div[role="button"]');
    if (googleButton) {
      googleButton.click();
    }
  }

  loginWithGoogle(): void {
    this.socialAuthService.signIn(GoogleLoginProvider.PROVIDER_ID);
  }
  loginWithFB(): void {
    this.socialAuthService.signIn(FacebookLoginProvider.PROVIDER_ID);
  }
  logOut(): void {
    this.socialAuthService.signOut();
  }
}
